import React, { useCallback, useEffect, useState } from 'react'
import { getConfig } from '../get-import-config'
import BaseActionButton from '../../Page/BaseActionButton'
import Modal from '../../Modal'
import ImportTeamRosterContent from './ImportTeamRosterContent'

const ImportTeamRoster = ({
  teamId,
  teamName,
  teamRosterId,
  onSuccess,
  orgId,
  disabled = false,
  disabledReason = '',
  // 'players' (default) or 'teamOfficials': which roster the file fills.
  rosterType = 'players',
  // Lets a page trigger this control from elsewhere (a dropdown item).
  buttonId,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const isTeamOfficials = rosterType === 'teamOfficials'
  const config = getConfig()
  const importTemplate = orgId
    ? isTeamOfficials
      ? config.multiTeamOfficials
      : config.multiTeamRoster
    : isTeamOfficials
    ? config.teamOfficials
    : config.roster
  const isMultiTeamRoster = orgId ? true : false

  const handleEsc = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    },
    [setIsOpen]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleEsc)
    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [handleEsc])

  const onToggle = () => {
    setIsOpen(!isOpen)
  }

  const link = (
    <BaseActionButton
      id={buttonId}
      name={orgId ? 'multi-roster' : 'upload'}
      title={disabled ? disabledReason : importTemplate?.label}
      onClick={() => {
        if (disabled) {
          return
        }
        onToggle()
      }}
      disabled={loading || disabled}
      busy={loading}
    />
  )

  return (
    <>
      {link}
      <Modal
        isOpen={isOpen}
        onClose={onToggle}
        shouldCloseOnOverlayClick={false}
      >
        {isOpen && (
          <ImportTeamRosterContent
            setLoading={setLoading}
            loading={loading}
            toggle={onToggle}
            importTemplate={importTemplate}
            teamName={teamName}
            teamRosterId={teamRosterId}
            teamId={teamId}
            onSuccess={onSuccess}
            orgId={orgId}
            isMultiTeamRoster={isMultiTeamRoster}
            rosterType={rosterType}
          />
        )}
      </Modal>
    </>
  )
}

export default ImportTeamRoster
